// section-custom-mosaic.js
(() => {
  const initialized = new WeakSet();
  function initMosaic(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const inner = root.querySelector('.custom-mosaic--inner');
    if (!inner) return;

    const contentSel   = '[data-mosaic-block-content]';
    const wrapperSel   = '.mosaic-block--content-wrapper';
    const expandedClass = 'mosaic-block--expanded';
    const compressBlocks = inner.classList.contains('custom-mosaic--compressed');
    const isMobile = () => !window.matchMedia('(min-width: 750px)').matches;

    const throttle = (fn, wait = 100) => {
      let last = 0, t;
      return (...args) => {
        const now = Date.now();
        const remaining = wait - (now - last);
        if (remaining <= 0) {
          clearTimeout(t); t = null; last = now; fn(...args);
        } else if (!t) {
          t = setTimeout(() => { t = null; last = Date.now(); fn(...args); }, remaining);
        }
      };
    };

    function adjustHeight(block) {
      const el = block instanceof Element ? block : root.querySelector(block);
      if (!el) return;
      const wrapper = el.querySelector(wrapperSel);
      if (!wrapper) return;

      const cs = window.getComputedStyle(el);
      const padTop = parseFloat(cs.paddingTop) || 0;
      const padBottom = parseFloat(cs.paddingBottom) || 0;
      const padSum = padTop + padBottom;

      const blockInner = el.clientHeight;
      const wrapperInner = wrapper.clientHeight;

      if (blockInner - padSum < wrapperInner) {
        el.style.height = `${wrapperInner + padSum}px`;
        wrapper.style.transform = 'none';
        wrapper.style.top = 'auto';
      }
    }

    function resetHeight(block) {
      const el = block instanceof Element ? block : root.querySelector(block);
      if (!el) return;
      const wrapper = el.querySelector(wrapperSel);
      el.style.height = '';
      if (wrapper) {
        wrapper.style.transform = '';
        wrapper.style.top = '';
      }
    }

    function expand(content) {
      if (!compressBlocks) return;
      content.classList.add('animating', 'animating-in');
      requestAnimationFrame(() => {
        content.classList.remove('animating', 'animating-in');
        content.classList.add(expandedClass);
      });
    }

    function collapse(content) {
      if (!compressBlocks) return;
      content.classList.add('animating', 'animating-out');
      requestAnimationFrame(() => {
        content.classList.remove('animating', 'animating-out', expandedClass);
        content.removeAttribute('data-clicked');
        resetHeight(content);
      });
    }

    function collapseOthers(active) {
      root.querySelectorAll(contentSel).forEach((el) => {
        if (el === active) return;
        if (el.classList.contains(expandedClass)) collapse(el);
        el.removeAttribute('data-clicked');
      });
    }

    function onClick(e) {
      const content = e.target.closest(contentSel);
      if (!content || !root.contains(content)) return;

      const clicked = content.getAttribute('data-clicked');
      if (clicked || !isMobile() || !compressBlocks) return;

      e.preventDefault();
      collapseOthers(content);
      content.setAttribute('data-clicked', 'clicked');
      expand(content);
    }

    function handleBreakpointChange() {
      if (!isMobile()) {
        root.querySelectorAll(`.${expandedClass}`).forEach(collapse);
        root.querySelectorAll(contentSel).forEach(resetHeight);
      } else if (!compressBlocks) {
        root.querySelectorAll(contentSel).forEach(adjustHeight);
      }
    }

    function onResize() {
      if (!compressBlocks) {
        root.querySelectorAll(contentSel).forEach((block) => {
          if (isMobile()) adjustHeight(block); else resetHeight(block);
        });
      }
      const mobileNow = isMobile();
      if (onResize._prevMobile !== mobileNow) {
        handleBreakpointChange();
        onResize._prevMobile = mobileNow;
      }
    }
    onResize._prevMobile = isMobile();

    // initial setup
    if (!compressBlocks && isMobile()) {
      root.querySelectorAll(contentSel).forEach(adjustHeight);
    }

    // Listeners
    root.addEventListener('click', onClick);
    const resizeHandler = throttle(onResize, 120);
    window.addEventListener('resize', resizeHandler, { passive: true });

    // Theme Editor
    const onBlockSelect = (ev) => {
      const { sectionId, blockId } = ev.detail || {};
      const myId = root.dataset.sectionId;
      if (sectionId !== myId) return;
      if (!isMobile()) return;
      const blockEl = document.getElementById(blockId);
      if (!blockEl) return;
      const content = blockEl.querySelector(contentSel);
      if (content){
        collapseOthers(content);
        expand(content);
      }
    };

    const onBlockDeselect = (ev) => {
      const { sectionId, blockId } = ev.detail || {};
      const myId = root.dataset.sectionId;
      if (sectionId !== myId) return;
      if (!isMobile()) return;
      const blockEl = document.getElementById(blockId);
      if (!blockEl) return;
      const content = blockEl.querySelector(contentSel);
      if (content) collapse(content);
    };

    const onSectionUnload = (ev) => {
      const { sectionId } = ev.detail || {};
      const myId = root.dataset.sectionId;
      if (sectionId !== myId) return;
      root.removeEventListener('click', onClick);
      window.removeEventListener('resize', resizeHandler);
      document.removeEventListener('shopify:block:select', onBlockSelect);
      document.removeEventListener('shopify:block:deselect', onBlockDeselect);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    };

    document.addEventListener('shopify:block:select', onBlockSelect);
    document.addEventListener('shopify:block:deselect', onBlockDeselect);
    document.addEventListener('shopify:section:unload', onSectionUnload);
  }

  function initAll(context = document) {
    context.querySelectorAll('[data-section-type="custom-mosaic"]').forEach(initMosaic);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  
  document.addEventListener('shopify:section:load', (ev) => {
    initAll(ev.target || undefined);
  });
})();
